import { render } from "./addLinkShow.vue?vue&type=template&id=35ae00fc&scoped=true&ts=true"
import script from "./addLinkShow.vue?vue&type=script&lang=ts"
export * from "./addLinkShow.vue?vue&type=script&lang=ts"

import "./addLinkShow.vue?vue&type=style&index=0&id=35ae00fc&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ae00fc"]])

export default __exports__